import "./App.scss";

import { createTheme, Grid, ThemeProvider, useMediaQuery } from "@mui/material";
import React from "react";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";

import ResponsiveAppBar from "./Components/ResponsiveAppBar";
import GameLibrary from "./Pages/GameLibrary";
import GameViewer from "./Pages/GameViewer";
import Home from "./Pages/Home";

function App() {
  // Dark Mode Support
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: "#749CD2",
          },
          mode: prefersDarkMode ? "dark" : "light",
        },
        shape: {
          borderRadius: 10,
        },
        components: {
          MuiAppBar: {
            styleOverrides: {
              colorPrimary: {
                backgroundColor: "#47658e"
              }
            }
          }
        }
      }),
    [prefersDarkMode],
  );

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ResponsiveAppBar />
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={10} style={{ paddingTop: "40px" }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/games" element={<GameLibrary />} />
              <Route path="/game/*" element={<GameViewer />} />
              <Route path="*" element={<div>404</div>} />
            </Routes>
          </Grid>
        </Grid>
      </ThemeProvider>
    </BrowserRouter >
  );
}

export default App;
